import Http from '@/services/http';

const http = Http.create();
export const useStreetView = () => {
	const getStreetView = async (address: string): Promise<string | null> => {
		if (!address) return null;
		const response = await http.get<Blob>('/maps/streetview', {
			params: { address },
			responseType: 'blob',
		});
		if (!response.data || response.data.size === 0) return null;
		return URL.createObjectURL(response.data);
	};

	return {
		getStreetView,
	};
};
